import {
  BookOpenIcon,
  ChartBarIcon,
  ChatBubbleLeftRightIcon,
  EnvelopeIcon,
  IdentificationIcon,
  PhoneIcon,
  RectangleStackIcon,
  CubeIcon,
  Square3Stack3DIcon,
  HomeIcon,
  CogIcon,
  SparklesIcon,
  AcademicCapIcon,
  ClipboardDocumentIcon,
  PlayCircleIcon,
  LanguageIcon,
  FlagIcon,
  MegaphoneIcon,
  UserGroupIcon,
  UsersIcon,
  BellIcon,
  SwatchIcon,
  RocketLaunchIcon,
  ArrowTrendingUpIcon,
  GlobeAltIcon,
  ChartPieIcon,
  BuildingLibraryIcon,
  ClockIcon,
  DocumentTextIcon,
} from '@heroicons/react/24/outline';
import { BiBrain as BrainIcon } from 'react-icons/bi';
import UserCircleIcon from '../components/application/halda-design-system/icons/UserCircleIcon';
import GridIcon from '../components/application/halda-design-system/icons/GridIcon';
import UserProfilesIcon from '../components/application/halda-design-system/icons/UserProfilesIcon';
import SettingsIcon from '../components/application/halda-design-system/icons/SettingsIcon';
import LogoutIcon from '../components/application/halda-design-system/icons/LogoutIcon';
import LayoutGridIcon from '../components/application/halda-design-system/icons/LayoutGridIcon';
import SmartFormIcon from '../components/application/halda-design-system/icons/SmartFormIcon';
import SparklingMagnifyingGlassIcon from '../components/application/halda-design-system/icons/SparklingMagnifyingGlassIcon';
import DevMenuIcon from '../components/application/halda-design-system/icons/DevMenuIcon';

const iconMap = {
  RectangleStackIcon,
  HomeIcon,
  BrainIcon,
  BookOpenIcon,
  CogIcon,
  ChartBarIcon,
  EnvelopeIcon,
  IdentificationIcon,
  PhoneIcon,
  CubeIcon,
  Square3Stack3DIcon,
  AcademicCapIcon,
  ClipboardDocumentIcon,
  SmartFormIcon,
  SparklesIcon,
  SparklingMagnifyingGlassIcon,
  PlayCircleIcon,
  LanguageIcon,
  FlagIcon,
  MegaphoneIcon,
  UserGroupIcon,
  UsersIcon,
  UserCircleIcon,
  BellIcon,
  SwatchIcon,
  GridIcon,
  LayoutGridIcon,
  UserProfilesIcon,
  SettingsIcon,
  ChatBubbleLeftRightIcon,
  RocketLaunchIcon,
  LogoutIcon,
  ArrowTrendingUpIcon,
  DevMenuIcon,
  GlobeAltIcon,
  ChartPieIcon,
  BuildingLibraryIcon,
  ClockIcon,
  DocumentTextIcon,
};

export default iconMap;
